import { createApp } from 'vue'

import karonte from '@tsyl/karonte'
import type { KaronteSettings } from '@tsyl/karonte/lib/types/settings'
import karonteComponents from '@tsyl/karonte-components'
import karonteDebug from '@tsyl/karonte-debug'
import karonteTsyl from '@tsyl/karonte-tsyl'
import karonteWidgets from '@tsyl/karonte-widgets'
import Zapan2 from '@tsyl/zapan2'
import type { ZapanSettings } from '@tsyl/zapan2/lib/types/Zapan'

import App from './App.vue'

import '@tsyl/karonte/style.css'

import '@tsyl/karonte-widgets/style.css'

import '@tsyl/karonte-components/style.css'

import '@tsyl/karonte-debug/style.css'

import '@tsyl/karonte-tsyl/style.css'

import '@tsyl/zapan2/style.css'

import vuetify from './plugins/vuetify'
import './plugins/date-fns'
import { loadFonts } from './plugins/webfontloader'

import { createPinia } from 'pinia'

import VueApexCharts from 'vue3-apexcharts'
import * as Sentry from '@sentry/vue'
import { createSentryPiniaPlugin } from '@sentry/vue'

import router from './router'
import { i18n } from './plugins/i18n'

const karonteSettings: KaronteSettings = {
  loggerLevel: 'debug',
  loggerPrint: 'warn',
  defaultLang: import.meta.env.VITE_DEFAULT_LANG,
  googleApiKey: import.meta.env.VITE_GOOGLE_API_KEY
}

import './styles/styles.scss'

const pinia = createPinia()

loadFonts()

const zapanConfig = {} as ZapanSettings

const app = createApp(App)

if (import.meta.env.VITE_USE_SENTRY === 'true') {
  Sentry.init({
    app,
    dsn: 'https://8b55ba6a92bfe65ebfe1b4a5ed0fdcee@o4509048122703872.ingest.us.sentry.io/4510419799638016',
    // Sentry 11 replaced `sendDefaultPii` with `dataCollection`; its defaults (user info, cookies, headers, ...)
    // keep collecting what `sendDefaultPii: true` enabled. Narrow it here if less data should be sent.
    environment: import.meta.env.VITE_CUSTOMER,
    initialScope: {
      tags: {
        appVersion: import.meta.env.__APP_VERSION__ || 'unknown'
      }
    },
    integrations: []
  })

  pinia.use(createSentryPiniaPlugin())
}

app
  .use(router)
  .use(i18n)
  .use(karonte, karonteSettings)
  .use(vuetify)
  .use(karonteWidgets)
  .use(karonteComponents)
  .use(karonteTsyl)
  .use(karonteDebug)
  .use(Zapan2, zapanConfig) // this generates a warning of "Plugin has already been applied to target app" due to Karonte internal imports
  .use(VueApexCharts)
  .use(pinia)
  .mount('#app')
